module.exports = __webpack_public_path__ + "img/supply.c03cfcb6.svg";